import React, { Component } from "react";

import supportHeroImg from "../../../../../../images/support-hero-img.jpg";
import playIcon from "../../../../../../images/modal-icons/play-btn.png";
import avatar from "../../../../../../images/avatar.png";
import supportPlaceholder from "../../../../../../images/support-img.jpg";
import supportPlaceholder2 from "../../../../../../images/support-img-2.jpg";
import navIcon from "../../../../../../images/nav-icon.svg";
import OwlCarousel from "react-owl-carousel";

import step1 from "../images/extensionManual/step1.png";
import step2 from "../images/extensionManual/step2.png";
import step2a from "../images/extensionManual/step2a.png";
import step3 from "../images/extensionManual/step3.png";
import step3a from "../images/extensionManual/step3a.png";
import step3b from "../images/extensionManual/step3b.png";
import step3c from "../images/extensionManual/step3c.png";
import step4 from "../images/extensionManual/step4.png";
import step5 from "../images/extensionManual/step5.png";

class ExtensionManual extends Component {
    render() {
        return (
            <div className="template-flex">
                <div className="skill-home scrollable">
                    <div className="tp-title">
                        <h3>Supervity Chrome Extension User Manual</h3>
                    </div>
                    <div className="doc-text">
                        <h4>Introduction</h4>
                        <p>The Super chrome extension is an integral part of Supervity, to give a brief the extension has the backend logic required to record the various show actions performed on Supervity. It also has a skill triggering mechanism on the user interface which can be used to trigger the various skills available.</p>
                        <h4>How to install the Supervity chrome extension</h4>
                        <p>Refer to this document to go through the detailed steps of the installation process. </p>
                        <h4>How to use the Supervity Chrome Extension</h4>
                        <ol type="number">
                            <li>
                                <p>After successful installation of the chrome plugin following the steps in the above attached document, you should be able to see a small icon on the right-side center of your chrome window with our logo as shown below. This is the Supervity chrome extension. </p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step1} />
                            <li>
                                <p>You should be able to see this on any webpage on chrome for example google.com, when hovered over on the small black bar on the right center edge of the screen. </p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step2} />
                            <img src={step2a} />
                            <li>
                                <p>When clicked on the extension you will see 4 tabs.</p>
                                <p>The first one is to view skill sets. Click on Skill Sets to see a list of all relevant skills based on the web application you are on. For Example, if you are on the AWS application and click on the Skill Sets tab on the extension it will show a list of all AWS based skill sets that are created and published to the skill hub. </p>
                                <div className="doc-img">
                                    <img src={step3} />
                                </div>
                                <p>The next tab is to view skills. Click on Skills tab to see a list of all relevant skills based on the web application you are on. For Example, if you are on the google application and click on the Skills tab it will show a list of all Google based skills that are created and published to the skill hub </p>
                                <div className="doc-img">
                                    <img src={step3a} />
                                </div>
                                <p>The next tab is our very own generative AI chatbot, Ask Super. You can click on this and ask any question that you may have during the skill execution journey. Super will intelligently understand the website's context and respond accordingly. You need not specify that you are on a particular web page looking for help. You can directly shoot your question and Super will respond. Have a look at the screenshot below where we asked a generic question about instances, and it automatically responded as per the AWS context because we are on the AWS webpage. </p>
                                <div className="doc-img">
                                    <img src={step3b} />
                                </div>
                                <p>The last tab is to collect feedback from our users in real time. You can clickon it and share a rating as well as comments on Supervity if any. Our customer success team will make sure to monitor and respond to the feedback. </p>
                                <div className="doc-img">
                                    <img src={step3c} />
                                </div>
                            </li>                            
                            <li>
                                <p>Click on any skill in the list to trigger the skill and go through the in app walkthrough.</p>
                                <div className="doc-img">
                                    <img src={step4} />
                                </div>
                            </li>                            
                            <li>
                                <p>Please note that you may use the Ask Super feature from here as well to ask any questions you may get in the middle of the skill execution. The number of steps in the current skill are shown on the top so that you are aware of how long the skill is. </p>
                                <div className="doc-img"></div>
                            </li>
                            <img src={step5} />
                        </ol>
                    </div>
                </div>
            </div>
        );
    };
}

export default ExtensionManual;